import React, { useEffect, useState } from 'react';
import ProtectedPageSidebar from '../../components/Sidebar/ProtectedPageSidebar';
import { useUserContext } from '../../context/UserContext';
import MobileHeader from '../../components/MobileHeader';
import { useLocation } from 'react-router-dom';
import { SettingsContentMobile, SettingsContent } from '../../features/AccountSettings/components/index';

export default function AccountSettings() {
  const location = useLocation();

  const { user, reloadUser } = useUserContext();
  const [showProfileSettings, setShowProfileSettings] = useState(false);

  const mediaMatch = window.matchMedia('(max-width: 900px)');
  const [isMobileView] = useState(mediaMatch.matches);

  useEffect(() => {
    const initUser = async () => {
      const vormatsUser = await reloadUser();
      setLoaded(true);
      console.log('User after init', vormatsUser);
    };
    if (!user) initUser();
  }, [reloadUser, user]);

  const [isLoaded, setLoaded] = useState(false);

  useEffect(() => {
    location.state?.showProfileSettings ? setShowProfileSettings(location.state?.showProfileSettings) : setShowProfileSettings(false);
  }, [location]);

  useEffect(() => {
    const initUser = async () => {
      const vormatsUser = await reloadUser();
      setLoaded(true);
      console.log('User after init', vormatsUser);
    };
    if (!user) initUser();
  }, [reloadUser, user]);

  useEffect(() => {
    const initUser = async () => {
      await reloadUser();
      setLoaded(true);
    };
    if (!user) {
      initUser();
    } else {
      setLoaded(true);
    }
  }, [user]);

  if (!isLoaded) {
    return null;
  }

  return (
    <>
      <ProtectedPageSidebar />
      <MobileHeader libraryMode={false} userAvatar={user?.avatarUri} userFirstLetter={user?.userFullName.charAt(0).toUpperCase()} />
      {isMobileView && !showProfileSettings ? <SettingsContentMobile /> : <SettingsContent />}
    </>
  );
}
